import React, { useState, useRef, useEffect } from 'react';
import TableUI from './TableUI';
import { Card } from 'reactstrap';
import { ThunderboltOutlined, BugOutlined } from '@ant-design/icons';
import { AiOutlineSearch } from 'react-icons/ai';
import { Input, Dropdown, Space, Tooltip, Select, DatePicker } from 'antd';
import UserAvatar from '../../../../components/userAvatar/index';
import {
  setsprintdata,
  setassigneelist,
  setbacklogdata,
  setEpiclist,
  setlabellist,
} from 'store/actions';
import { useDispatch, useSelector } from 'react-redux';
import SkeletonWithLoaders from 'components/common/Spinner';
import { Flex } from '@chakra-ui/react';
import SubtaskObject from '@atlaskit/object/subtask';
import dayjs from 'dayjs';
import './Table.css';
import httpInjectorService from 'services/http-injector.service';
import { useParams } from 'react-router-dom';
import { setProjectName } from 'store/actions';
import FilterListdata from './FilterListdata';
import TaskObject from '@atlaskit/object/task';
import StoryObject from '@atlaskit/object/story';
import BugObject from '@atlaskit/object/bug';
import EpicObject from '@atlaskit/object/epic';
import { toast } from 'react-toastify';

const { Option } = Select;

const Table = () => {
  const [searchTerm, setSearchTerm] = useState('');
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [statusOptions, setStatusOptions] = useState([]);
  const [tasksByStatus, setTasksByStatus] = useState({});
  const [epicDetails, setEpicDetails] = useState([]);

  const [taskDetails, setTaskDetails] = useState([]);
  const [subtaskDetails, setSubtaskDetails] = useState([]);
  const [sprintList, setSprintList] = useState([]);

  const [selectedTypes, setSelectedTypes] = useState([]);
  const [selectedStatuses, setSelectedStatuses] = useState([]);
  const [selectedAssignees, setSelectedAssignees] = useState([]);
  const [originalEpics, setOriginalEpics] = useState([]);
  const [issueTypes, setIssueTypes] = useState([]);

  const dispatch = useDispatch();
  const { id } = useParams();
  const projectId = Number(id);

  const assigneeOptions = useSelector(
    (state) => state.Authentication?.assigneelist,
  );

  const epicOptions = useSelector((state) => state.Authentication?.Epiclist);

  const labelOptions = useSelector((state) => state.Authentication?.labellist);

  const projectName = useSelector((state) => state.Authentication?.projectName);

  const dropdownRef = useRef(null);
  const [epics, setEpics] = useState([]);

  const MAX_VISIBLE = 4;
  const visible = assigneeOptions.slice?.(0, MAX_VISIBLE);
  const hidden = assigneeOptions.slice?.(MAX_VISIBLE);

  const getListData = async () => {
    setLoading(true);
    const payload = { project_id: projectId };
    try {
      const response = await httpInjectorService.getListData(payload);

      if (response?.status === 'success') {
        //const projectName = response.data.project_name;
        await dispatch(setProjectName(projectName));

        const epicData = response.data || [];

        // ================= EPICS =================
        const allEpics = epicData.map((epic) => ({
          ...epic,
          type: 'epic',
          project_id: projectId,
          epic_id: epic.epic_id,
          epic_key: epic.epic_key,
        }));

        // ================= TASKS =================
        const allTasks = epicData.flatMap((epic) =>
          (epic.tasks || []).map((task) => ({
            ...task,
            type: 'task',
            project_id: projectId,
            epic_id: epic.epic_id,
            epic_key: epic.epic_key,
          })),
        );

        // ================= SUBTASKS =================
        const allSubtasks = epicData.flatMap((epic) =>
          (epic.tasks || []).flatMap((task) =>
            (task.subtasks || []).map((subtask) => ({
              ...subtask,
              type: 'subtask',
              project_id: projectId,
              epic_id: epic.epic_id,
              epic_key: epic.epic_key,
              issue_id: task.issue_id,
              issue_key: task.issue_key,
            })),
          ),
        );

        const formattedEpics = epicData.map((epic) => ({
          ...epic,
          isExpanded: false,
          tasks: epic.tasks.map((task) => ({ ...task, isExpanded: false })),
        }));

        setEpics(formattedEpics);
        setOriginalEpics(formattedEpics);

        // ================= SET STATE =================
        setEpics(
          epicData.map((epic) => ({
            ...epic,
            isExpanded: false,
            tasks: epic.tasks.map((task) => ({ ...task, isExpanded: false })),
          })),
        );
        setEpicDetails(allEpics);
        setTaskDetails(allTasks);
        setSubtaskDetails(allSubtasks);
      }
    } catch (error) {
      console.error('Error fetching list data:', error);
    } finally {
      setLoading(false);
    }
  };

  const fetchMetadata = async (projectId) => {
    try {
      const [assigneeRes, epicRes, statusRes, labelRes] = await Promise.all([
        httpInjectorService.getProjectAssigneeList(projectId),
        httpInjectorService.getEpicList(projectId),
        httpInjectorService.ListBoardStatus(projectId),
        httpInjectorService.getLabelList(projectId),
      ]);

      //  Assignee
      if (
        assigneeRes?.status === 'success' &&
        Array.isArray(assigneeRes.data)
      ) {
        //setAssigneeOptions(assigneeRes.data);
        dispatch(setassigneelist(assigneeRes.data));
      } else {
        //setAssigneeOptions([]);
        dispatch(setassigneelist([]));
      }

      //  Epics
      if (epicRes?.status === 'success' && Array.isArray(epicRes.data)) {
        //setEpicOptions(epicRes.data);
        dispatch(setEpiclist(epicRes.data));
      } else {
        //setEpicOptions([]);
        dispatch(setEpiclist([]));
      }

      //  Statuses
      if (statusRes?.status === 'success' && Array.isArray(statusRes.data)) {
        setStatusOptions(statusRes.data);
        const initialTasks = {};
        statusRes.data.forEach((s) => {
          initialTasks[s.status_name] = [];
        });
        setTasksByStatus(initialTasks);
      } else {
        setStatusOptions([]);
      }

      //Labels
      if (labelRes?.status === 'success' && Array.isArray(labelRes.data)) {
        // setLabelOptions(labelRes.data);
        dispatch(setlabellist(labelRes.data));
        const labelIds = labelRes.data.map((label) => label.label_id);
      } else {
        //setLabelOptions([]);
        dispatch(setlabellist([]));
      }
    } catch (error) {
      console.error('Error fetching board data:', error);
      //setAssigneeOptions([]);
      //setEpicOptions([]);
      setStatusOptions([]);
      //setLabelOptions([]);
      //dispatch(setassigneelist([]));
      dispatch(setEpiclist([]));
      dispatch(setlabellist([]));
    }
  };

  const getsprintlist = async () => {
    try {
      let response = await httpInjectorService.getsprintList(projectId);

      if (response.status === 'success') {
        const activeSprints = (response.data?.active_sprints || []).filter(
          (sprint) => sprint.sprint_name?.toLowerCase() !== 'backlog',
        );

        const futureSprints = (response.data?.future_sprints || []).filter(
          (sprint) => sprint.sprint_name?.toLowerCase() !== 'backlog',
        );

        const sprintOptions = [
          ...activeSprints.map((sprint) => ({
            label: sprint.sprint_name,
            value: sprint.sprint_id,
          })),
          ...futureSprints.map((sprint) => ({
            label: sprint.sprint_name,
            value: sprint.sprint_id,
          })),
        ];

        setSprintList(sprintOptions);
      } else {
        setSprintList([]);
      }
    } catch (error) {
      console.error('Error fetching sprint list:', error);
      setSprintList([]);
    }
  };

  const normalizeLabels = (labels) => {
    if (!labels) return [];

    // backend sends string: "[backend, d a, DA]"
    if (typeof labels === 'string') {
      return labels
        .replace(/[\[\]]/g, '')
        .split(',')
        .map((l) => l.trim())
        .filter(Boolean)
        .map((name) => ({
          label_id: name,
          label_name: name,
        }));
    }

    // backend sends array
    if (Array.isArray(labels)) {
      return labels.map((l) => ({
        label_id: l.label_id || l.value,
        label_name: l.label_name || l.label,
      }));
    }

    return [];
  };

  const normalizeFlatListToEpics = (list) => {
    const epicMap = {};

    list.forEach((item) => {
      const epicId = item.epic_id || 'NO_EPIC';

      // ---------------- EPIC ----------------
      if (!epicMap[epicId]) {
        const isEpicItem = !item.issue_id && !item.subtask_id;
        epicMap[epicId] = {
          epic_id: item.epic_id,
          epic_key: item.epic_key,
          epic_name: item.epic_name,
          reporter_name: item.reporter_name,
          assignee_name: isEpicItem ? item.assignee_name : null,
          epic_status: isEpicItem ? item.epic_status : null,
          due_date: isEpicItem ? item.due_date : null,
          created_at: isEpicItem ? item.created_at : null,
          updated_at: isEpicItem ? item.updated_at : null,
          sprint_name: isEpicItem ? item.sprint_name : null,
          type: 'epic',
          isExpanded: true,
          tasks: [],
          labels: normalizeLabels(item.labels),
        };
      }

      // ---------------- TASK ----------------
      if (item.issue_id && !item.subtask_id) {
        const exists = epicMap[epicId].tasks.find(
          (t) => t.issue_id === item.issue_id,
        );

        if (!exists) {
          epicMap[epicId].tasks.push({
            issue_id: item.issue_id,
            issue_type_id: item.issue_type_id,
            issue_key: item.issue_key,
            issue_title: item.issue_title,
            issue_status: item.issue_status,
            assignee_id: item.assignee_id,
            assignee_name: item.assignee_name,
            reporter_name: item.reporter_name,
            sprint_name: item.sprint_name,
            due_date: item.due_date,
            created_at: item.created_at,
            updated_at: item.updated_at,
            labels: normalizeLabels(item.labels),
            type: 'issue',
            isExpanded: true,
            subtasks: [],
          });
        }
      }

      // ---------------- SUBTASK ----------------
      if (item.subtask_id) {
        let task = epicMap[epicId].tasks.find(
          (t) => t.issue_id === item.issue_id,
        );

        if (!task) {
          task = {
            issue_id: item.issue_id,
            issue_type_id: item.issue_type_id,
            issue_key: item.issue_key,
            issue_title: item.issue_title,
            issue_status: item.issue_status,
            assignee_id: item.issue_assignee_id,
            assignee_name: item.issue_assignee_name || item.assignee_name,
            reporter_name: item.reporter_name,
            sprint_name: item.issue_sprint_name,
            due_date: item.issue_due_date,
            created_at: item.issue_created_at,
            updated_at: item.issue_updated_at,
            labels: normalizeLabels(item.labels),
            type: 'issue',
            isExpanded: true,
            subtasks: [],
          };
          epicMap[epicId].tasks.push(task);
        }

        task.subtasks.push({
          subtask_id: item.subtask_id,
          subtask_key: item.subtask_key,
          title: item.title,
          subtask_status: item.subtask_status,
          assignee_id: item.subtask_assignee_id,
          assignee_name: item.assignee_name,
          reporter_name: item.reporter_name,
          due_date: item.due_date,
          created_at: item.created_at,
          updated_at: item.updated_at,
          sprint_name: item.sprint_name,
          labels: normalizeLabels(item.labels),
          type: 'subtask',
        });
      }
    });

    return Object.values(epicMap);
  };

  const buildFilterPayload = () => {
    const payload = {
      project_id: projectId,
    };

    if (selectedTypes.length) {
      const mapTypeValueToName = (v) => {
        const s = String(v).toLowerCase();
        if (s === '1') return 'task';
        if (s === '2') return 'story';
        if (s === '3') return 'bug';
        if (s === 'epic') return 'epic';
        if (s === 'subtask') return 'subtask';
        return s;
      };

      payload.type = selectedTypes.map(mapTypeValueToName);
    }

    if (selectedAssignees.length) {
      payload.assignee_id = selectedAssignees;
    }

    if (selectedStatuses.length) {
      payload.status = selectedStatuses;
    }

    return payload;
  };

  const applyFilters = async () => {
    const payload = buildFilterPayload();

    try {
      setLoading(true);

      const response = await httpInjectorService.listFilteredDetails(payload);

      if (response?.status !== 'success') return;

      const data = response.data;

      const filtersApplied =
        selectedTypes.length || selectedStatuses.length || selectedAssignees.length;

      if (!Array.isArray(data) || data.length === 0) {
        if (filtersApplied) toast.error('No Task Found');
        await getListData();
        return;
      }

      const normalizedEpics = normalizeFlatListToEpics(data);
      setEpics(normalizedEpics);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (
      selectedTypes.length ||
      selectedStatuses.length ||
      selectedAssignees.length
    ) {
      applyFilters();
    } else {
      getListData();
    }
  }, [selectedTypes, selectedStatuses, selectedAssignees]);

  useEffect(() => {
    if (projectId) {
      getListData();
      getsprintlist();
    }
  }, [projectId]);

  useEffect(() => {
    if (projectId) {
      fetchMetadata(projectId);
    }
  }, [projectId]);

  const updateItemField = (row, field, value) => {
    setEpics((prev) =>
      prev.map((epic) => {
        // ===== EPIC =====
        if (row.rowType === 'epic' && epic.epic_id === row.entityId) {
          return {
            ...epic,
            ...(field === 'status' && { epic_status: value }),
            ...(field === 'assignee' && { assignee_name: value }),
            ...(field === 'dueDate' && { due_date: value }),
            ...(field === 'sprint' && { sprint_name: value }),
            ...(field === 'summary' && { epic_name: value }),
            ...(field === 'labels' && { labels: value }),
          };
        }

        return {
          ...epic,
          tasks: epic.tasks.map((task) => {
            // ===== TASK =====
            if (row.rowType === 'task' && task.issue_id === row.entityId) {
              return {
                ...task,
                ...(field === 'status' && { issue_status: value }),
                ...(field === 'assignee' && { assignee_name: value }),
                ...(field === 'dueDate' && { due_date: value }),
                ...(field === 'sprint' && { sprint_name: value }),
                ...(field === 'summary' && { issue_title: value }),
                ...(field === 'labels' && { labels: value }),
              };
            }

            return {
              ...task,
              subtasks: task.subtasks.map((sub) =>
                row.rowType === 'subtask' && sub.subtask_id === row.entityId
                  ? {
                      ...sub,
                      ...(field === 'status' && { subtask_status: value }),
                      ...(field === 'assignee' && { assignee_name: value }),
                      ...(field === 'dueDate' && { due_date: value }),
                      ...(field === 'labels' && { labels: value }),
                    }
                  : sub,
              ),
            };
          }),
        };
      }),
    );
  };

  const [editingCell, setEditingCell] = useState({
    rowId: null,
    field: null,
  });

  const isEditing = (record, field) =>
    editingCell.rowId === record.id && editingCell.field === field;

  const handleCellSave = async (record, field, value) => {
    updateItemField(record, field, value);
    try {
      if (record.rowType === 'epic') {
        if (field === 'labels') {
          await handleAddEpicLabel(record.entityId, value);
        } else {
          const epic = epicDetails.find((e) => e.epic_id === record.entityId);
          if (epic) {
            const finalBody = {
              project_id: projectId,
              epic_id: epic.epic_id,
              epic_name: field === 'summary' ? value : epic.epic_name,
              sprint_id:
                field === 'sprint'
                  ? sprintList.find((s) => s.label === value)?.value || null
                  : epic.sprint_id,
              epic_story_points: epic.epic_story_points,
              assignee_id:
                field === 'assignee'
                  ? assigneeOptions.find((a) => a.username === value)
                      ?.user_id || null
                  : epic.assignee_id,
              description: epic.description,
              epic_status: field === 'status' ? value : epic.epic_status,
              issue_priority: epic.issue_priority,
              start_date: epic.start_date,
              due_date:
                field === 'dueDate'
                  ? value
                  : epic.due_date
                    ? dayjs(epic.due_date).format('YYYY-MM-DD')
                    : null,

              epic_colour: epic.epic_colour,
            };
            await httpInjectorService.UpdateEpicDetails(finalBody);
          }
        }
      } else if (record.rowType === 'task') {
        if (field === 'labels') {
          await handleAddLabel(record.entityId, value);
        } else {
          await autoTaskSave(record.entityId, field, value);
        }
      } else if (record.rowType === 'subtask') {
        if (field === 'labels') {
          await subtaskLabelUpdate(record.entityId, value);
        } else {
          await autoSaveSubtask(record.entityId, field, value);
        }
      }
    } catch (error) {
      console.error('Error updating:', error);
    }
    setEditingCell({ rowId: null, field: null });
  };

  const toggleEpic = (epicId) => {
    setEpics((prev) =>
      prev.map((e) =>
        e.epic_id === epicId ? { ...e, isExpanded: !e.isExpanded } : e,
      ),
    );
  };

  const toggleTask = (epicId, taskId) => {
    setEpics((prev) =>
      prev.map((e) =>
        e.epic_id !== epicId
          ? e
          : {
              ...e,
              tasks: e.tasks.map((t) =>
                t.issue_id === taskId ? { ...t, isExpanded: !t.isExpanded } : t,
              ),
            },
      ),
    );
  };

  const handleAssigneeClick = (user_id) => {
    setSelectedAssignees((prev) =>
      prev.includes(user_id)
        ? prev.filter((id) => id !== user_id)
        : [...prev, user_id],
    );
  };

  const handleAddEpicLabel = async (epicId, updatedLabels) => {
    try {
      if (!updatedLabels || updatedLabels.length === 0) {
        const requestBody = {
          project_id: projectId,
          epic_id: epicId,
          labels_id: [],
        };
        const response =
          await httpInjectorService.createandADDepicLabels(requestBody);
        if (response.status !== 'success') {
          // error
        }
      } else {
        const newLabels = updatedLabels.filter((label) => label.__isNew__);
        const existingLabels = updatedLabels.filter(
          (label) => !label.__isNew__,
        );

        const newLabelNames = newLabels.map((label) => label.label);
        const existingLabelIds = existingLabels.map(
          (label) => label.label_id || label.value,
        );

        const requestBody = {
          project_id: projectId,
          epic_id: epicId,
        };

        if (newLabelNames.length > 0) {
          requestBody.new_labels = newLabelNames;
        }

        requestBody.labels_id = existingLabelIds;

        const response =
          await httpInjectorService.createandADDepicLabels(requestBody);

        if (response.status !== 'success') {
          //getListData()
        }
      }
    } catch (error) {
      console.error(error);
      // toast.error('Something went wrong while adding labels', {
      //   position: 'top-right',
      //   autoClose: 3000,
      // });
    }
  };

  const autoTaskSave = async (taskId, field, value) => {
    const task = taskDetails.find((t) => t.issue_id === taskId);
    if (!task) return;

    const payload = {
      issue_id: task.issue_id,
      issue_type_id: task.issue_type_id,
      project_id: task.project_id,
      epic_id: task.epic_id || null,
      sprint_id: task.sprint_id || null,
      story_points: task.story_points || null,
      assignee_id: task.assignee_id || null,
      issue_priority: task.issue_priority || null,
      issue_status: task.issue_status || null,
      issue_title: task.issue_title || '',
      description: task.description || '',
      start_date: task.start_date
        ? dayjs(task.start_date).format('YYYY-MM-DD')
        : null,
      due_date: task.due_date
        ? dayjs(task.due_date).format('YYYY-MM-DD')
        : null,
    };

    const fieldMapping = {
      status: 'issue_status',
      assignee: 'assignee_id',
      dueDate: 'due_date',
      sprint: 'sprint_id',
    };

    const mappedField = fieldMapping[field] || field;

    if (field === 'assignee') {
      const user = assigneeOptions.find((a) => a.username === value);
      payload.assignee_id = user ? user.user_id : null;
    } else {
      payload[mappedField] = value;
    }

    try {
      const res = await httpInjectorService.Taskedit(payload);

      if (res?.status === 'success') {
        //getListData()
      }
    } catch (error) {
      console.error('AutoSave failed:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleAddLabel = async (taskId, updatedLabels) => {
    try {
      if (!updatedLabels || updatedLabels.length === 0) {
        const requestBody = {
          issue_id: taskId,
          issue_type_id: taskDetails.issue_type_id,
          project_id: projectId,
          label_ids: [],
        };
        const response = await httpInjectorService.createLabel(requestBody);
      } else {
        const newLabels = updatedLabels.filter((label) => label.__isNew__);
        const existingLabels = updatedLabels.filter(
          (label) => !label.__isNew__,
        );

        const newLabelNames = newLabels.map((label) => label.label);

        const existingLabelIds = existingLabels.map(
          (label) => label.label_id || label.value,
        );

        const requestBody = {
          issue_id: taskId,
          issue_type_id: taskDetails.issue_type_id,
          project_id: projectId,
          label_ids: [...newLabelNames, ...existingLabelIds],
        };

        const response = await httpInjectorService.createLabel(requestBody);

        if (response.status === 'success') {
          getListData();
        } else {
          // error
        }
      }
    } catch (error) {
      console.error(error);
      // toast.error('Something went wrong while adding labels', {
      //   position: 'top-right',
      //   autoClose: 3000,
      // });
    }
  };

  const formatDate = (date) => (date ? dayjs(date).format('YYYY-MM-DD') : null);

  const autoSaveSubtask = async (subtaskId, field, value) => {
    const subtask = subtaskDetails.find((s) => s.subtask_id === subtaskId);
    if (!subtask) return;

    const payload = {
      project_id: projectId,
      issue_id: subtask.task_id,
      issue_type_id: subtask.issue_type_id,
      subtask_id: subtask.subtask_id,

      title: subtask.subtask_title || subtask.title || ' ',
      description: subtask.description || '',

      subtask_status: subtask.status || subtask.subtask_status || 'TODO',

      subtask_assignee_id: subtask.assignee_id ?? null,
      epic_id: subtask.epic_id ?? null,
      story_points: subtask.story_points ?? null,

      start_date: formatDate(subtask.start_date),
      due_date: formatDate(subtask.due_date),
    };

    if (field === 'summary') {
      payload.title = value;
    }

    if (field === 'assignee') {
      const user = assigneeOptions.find((a) => a.username === value);
      payload.subtask_assignee_id = user
        ? user.user_id
        : payload.subtask_assignee_id;
    }

    if (field === 'dueDate') {
      payload.due_date = formatDate(value);
    }

    if (field === 'status') {
      payload.subtask_status = value;
    }

    try {
      const res = await httpInjectorService.updatesubtaskdata(payload);

      if (res?.status === 'success') {
        //getListData()
      }
    } catch (error) {
      console.error('AutoSave Subtask Failed:', error);
    } finally {
      setLoading(false);
    }
  };

  const subtaskLabelUpdate = async (subtaskId, updatedLabels) => {
    try {
      if (!updatedLabels) {
        const requestBody = {
          project_id: projectId,
          subtask_id: subtaskId,
          labels_id: [],
        };
        const response =
          await httpInjectorService.updateSubtaskLabels(requestBody);
      } else {
        const newLabels = updatedLabels.filter((label) => label.__isNew__);
        const newLabelNames = newLabels.map((label) => label.label);

        const existingLabels = updatedLabels.filter(
          (label) => !label.__isNew__,
        );
        const existingLabelIds = existingLabels.map(
          (label) => label.label_id || label.value,
        );

        const requestBody = {
          project_id: projectId,
          subtask_id: subtaskId,
        };

        if (newLabelNames.length > 0) {
          requestBody.new_labels = newLabelNames;
        }

        if (existingLabelIds.length > 0) {
          requestBody.labels_id = existingLabelIds;
        }

        const response =
          await httpInjectorService.updateSubtaskLabels(requestBody);

        if (response.status === 'success') {
          //getListData()
        } else {
          // error
        }
      }
    } catch (error) {
      console.error(error);
      // //toast.error('Something went wrong while adding labels', {
      //   position: 'top-right',
      //   autoClose: 3000,
      // });
    }
  };

  const getIssueTypes = async () => {
    try {
      const response = await httpInjectorService.getIssueTypes();

      if (response.status === 'success') {
        setIssueTypes(response.data);
      }
    } catch (error) {
      throw error;
    }
  };

  useEffect(() => {
    getIssueTypes(); 
  }, []);

  return (
    <div
      style={{
        position: 'fixed',
        top: 175,
        left: 50,
        right: 0,
        bottom: 0,
        background: '#fff',
        overflowX: 'auto',
        overflowY: 'auto',
      }}
    >
      <Card
        style={{
          border: 'none',
          paddingLeft: 40,
          paddingRight: 30,
          paddingBottom: 20,
          background: '#fff',
        }}
      >
        <div
          className="mt-2"
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: 12,
            padding: '8px 16px',
            borderBottom: '1px solid #f0f0f0',
            background: '#fff',
            position: 'sticky',
            top: 0,
            zIndex: 20,

          }}
         
          data-tour="list-filters"
        >
          <Input
            prefix={<AiOutlineSearch />}
            placeholder="Search list..."
            style={{ width: '200px' }}
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            allowClear
          />

          <Space style={{ position: 'relative', display: 'flex' }}>
            {visible.map((a, index) => {
              const isSelected = selectedAssignees.includes(a.user_id);
              return (
                <Tooltip key={a.user_id} title={a.username}>
                  <div
                    onClick={() => handleAssigneeClick(a.user_id)}
                    style={{
                      border: isSelected
                        ? '2px solid #1677ff'
                        : '2px solid white',
                      borderRadius: '50%',
                      boxShadow: isSelected
                        ? '0 0 5px rgba(22,119,255,0.4)'
                        : 'none',
                      marginLeft: index === 0 ? 0 : -8,
                      cursor: 'pointer',
                      transition: '0.2s',
                      background: '#fff',
                    }}
                  >
                    <UserAvatar username={a.username} size={32} />
                  </div>
                </Tooltip>
              );
            })}

            {hidden.length > 0 && (
              <div
                ref={dropdownRef}
                style={{
                  position: 'relative',
                  display: 'inline-block',
                }}
              >
                <div
                  style={{
                    width: 32,
                    height: 32,
                    borderRadius: '50%',
                    background: '#f5f5f5',
                    color: '#555',
                    fontSize: 13,
                    fontWeight: 500,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    marginLeft: -8,
                    cursor: 'pointer',
                    border: '2px solid white',
                  }}
                  onClick={(e) => {
                    e.stopPropagation();
                    setDropdownOpen((prev) => !prev);
                  }}
                >
                  +{hidden.length}
                </div>

                {/* Custom popup menu */}
                {dropdownOpen && (
                  <div
                    style={{
                      position: 'absolute',
                      top: 40,
                      right: 0,
                      width: 220,
                      maxHeight: 300,
                      overflowY: 'auto',
                      background: '#fff',
                      border: '1px solid #f0f0f0',
                      borderRadius: 8,
                      padding: 8,
                      boxShadow: '0 8px 24px rgba(0,0,0,0.12)',
                      zIndex: 1200,
                    }}
                    onClick={(e) => e.stopPropagation()}
                  >
                    {hidden.map((a) => {
                      const isSelected = selectedAssignees.includes(a.user_id);
                      return (
                        <div
                          key={a.user_id}
                          onClick={() => handleAssigneeClick(a.user_id)}
                          style={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: 8,
                            padding: '8px',
                            borderRadius: 6,
                            background: isSelected
                              ? 'rgba(22,119,255,0.08)'
                              : 'transparent',
                            cursor: 'pointer',
                            marginBottom: 6,
                          }}
                        >
                          <UserAvatar username={a.username} size={24} />
                          <span style={{ flex: 1, fontSize: 13 }}>
                            {a.username}
                          </span>
                          {isSelected && (
                            <span
                              style={{
                                color: '#1677ff',
                                fontWeight: 700,
                              }}
                            >
                              ✓
                            </span>
                          )}
                        </div>
                      );
                    })}
                  </div>
                )}
              </div>
            )}
          </Space>

          <Select
            mode="multiple"
            allowClear
            placeholder="Filter by Type"
            style={{ width: 180 }}
            getPopupContainer={(triggerNode) => triggerNode.parentNode}
            value={selectedTypes}
            onChange={(val) => setSelectedTypes(val)}
          >
            <Option value="Epic">
              <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                <EpicObject width={20} stroke="#172B4D" />
                <span>Epic</span>
              </div>
            </Option>

            <Option value="1">
              <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                <TaskObject width={20} stroke="#0052CC" />
                <span>Task</span>
              </div>
            </Option>

            <Option value="2">
              <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                <StoryObject width={20} stroke="#36B37E" />
                <span>Story</span>
              </div>
            </Option>

            <Option value="3">
              <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                <BugObject width={20} stroke="#172B4D" />
                <span>Bug</span>
              </div>
            </Option>

            <Option value="Subtask">
              <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                <SubtaskObject width={20} stroke="#6554C0" />
                <span>Subtask</span>
              </div>
            </Option>
          </Select>

          <Select
            mode="multiple"
            allowClear
            //onClear={handleClear}
            placeholder="Filter by status"
            style={{ width: 180 }}
            options={statusOptions.map((l) => ({
              label: l.status_name,
              value: l.status_name,
            }))}
            value={selectedStatuses}
            onChange={(val) => setSelectedStatuses(val)}
            getPopupContainer={(triggerNode) => triggerNode.parentNode}
          />
        </div>
        {loading ? (
          <Flex justify="center" align="center" w="100%" h="300px" mt="55px">
            <SkeletonWithLoaders />
          </Flex>
        ) : (
          <div data-tour="list-table">
          <TableUI
            data-tour="list-table"
            epics={epics}
            toggleEpic={toggleEpic}
            toggleTask={toggleTask}
            assigneeOptions={assigneeOptions}
            isEditing={isEditing}
            setEditingCell={setEditingCell}
            handleCellSave={handleCellSave}
            getListData={getListData}
            epicOptions={epicOptions}
            taskDetails={taskDetails}
            statusOptions={statusOptions}
            sprintOptions={sprintList}
            labelOptions={labelOptions}
            projectId={projectId}
            subtaskDetails={subtaskDetails}
            epicDetails={epicDetails}
            isFiltered={
              selectedTypes.length > 0 ||
              selectedStatuses.length > 0 ||
              selectedAssignees.length > 0
            }
            searchTerm={searchTerm}
            selectedTypes={selectedTypes}
            selectedStatuses={selectedStatuses}
            selectedAssignees={selectedAssignees}
            issueTypes={issueTypes}
          />
          </div>
        )}
      </Card>
    </div>
  );
};

export default Table;
